var DRAFT_PREFIX = 'contract_builder_draft_';
var TEMPLATE_DRAFT_PREFIX = 'contract_template_builder_draft_';
export function getContractDraftKey(contractId) {
  return "".concat(DRAFT_PREFIX).concat(contractId);
}
export function getContractTemplateDraftKey(templateId) {
  return "".concat(TEMPLATE_DRAFT_PREFIX).concat(templateId);
}
function saveDraftToSession(key, design, html) {
  if (!key) {
    return;
  }
  try {
    sessionStorage.setItem(key, JSON.stringify({
      design: design,
      html: html,
      savedAt: Date.now()
    }));
  } catch (error) {
    console.warn('Failed to save contract builder draft to session', error);
  }
}
function loadDraftFromSession(key) {
  if (!key) {
    return null;
  }
  try {
    var raw = sessionStorage.getItem(key);
    if (!raw) {
      return null;
    }
    return JSON.parse(raw);
  } catch (error) {
    console.warn('Failed to load contract builder draft from session', error);
    return null;
  }
}
function clearDraftFromSession(key) {
  if (!key) {
    return;
  }
  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    console.warn('Failed to clear contract builder draft from session', error);
  }
}
export function saveContractDraftToSession(contractId, design, html) {
  saveDraftToSession(getContractDraftKey(contractId), design, html);
}
export function loadContractDraftFromSession(contractId) {
  return loadDraftFromSession(getContractDraftKey(contractId));
}
export function clearContractDraftFromSession(contractId) {
  clearDraftFromSession(getContractDraftKey(contractId));
}
export function saveContractTemplateDraftToSession(templateId, design, html) {
  saveDraftToSession(getContractTemplateDraftKey(templateId), design, html);
}
export function loadContractTemplateDraftFromSession(templateId) {
  return loadDraftFromSession(getContractTemplateDraftKey(templateId));
}
export function clearContractTemplateDraftFromSession(templateId) {
  clearDraftFromSession(getContractTemplateDraftKey(templateId));
}